import {safeTemplateValue,type TemplateNode} from '@/uptk/core/components/moduleEntity/template/templateTypes';

type ElementNode=Extract<TemplateNode,{type:'el'}>;
/** Restore compiler omissions in retained native trees only against an unambiguous captured option list.
 * Existing values and all bindings remain authoritative. No entity or module vocabulary is involved. */
export function restoreOptionValues(root:TemplateNode,capture:TemplateNode,messages:Record<string,Record<string,string>>):TemplateNode{
 const text=(node:TemplateNode):string=>node.type==='text'?(node.token??messages[node.i18n??'']?.fr??''):node.type==='el'?node.children.map(text).join(''):'';
 const options=(node:ElementNode):ElementNode[]=>node.children.filter((child):child is ElementNode=>child.type==='el'&&child.tag==='option');
 const lists=new Map<string,Map<string,string[]>>();
 const captured:{labels:string[];values:string[]}[]=[];
 const dynamicLabel=(node:TemplateNode):boolean=>node.type==='el'?node.children.some(dynamicLabel):node.type!=='text';
 const visit=(node:TemplateNode,action:(node:ElementNode)=>void):void=>{
  if(node.type==='el'){action(node);node.children.forEach(child=>visit(child,action));}
  else if(node.type==='repeat'){visit(node.item,action);visit(node.empty,action);}
  else if(node.type==='calculator-template')visit(node.root,action);
 };
 visit(capture,node=>{
  if(node.tag!=='select')return;
  const choices=options(node);if(!choices.some(choice=>text(choice).trim())||choices.some(choice=>choice.attrs?.value===undefined||!safeTemplateValue(choice.attrs.value,'value')))return;
  const key=JSON.stringify(choices.map(text)),values=choices.map(choice=>choice.attrs!.value),variants=lists.get(key)??new Map<string,string[]>();
  variants.set(JSON.stringify(values),values);lists.set(key,variants);
  captured.push({labels:choices.map(text),values});
 });
 const next=structuredClone(root);
 visit(next,node=>{
  if(node.tag!=='select')return;
  const choices=options(node),labels=choices.map(text),dynamic=choices.map(dynamicLabel);
  let variants=lists.get(JSON.stringify(labels));
  // A reviewed label binding can coexist with a literal option key. At least two
  // distinct static labels must prove the list; all matching captures must agree.
  if(dynamic.some(Boolean)&&new Set(labels.filter((label,index)=>!dynamic[index]&&label.trim())).size>=2){
   variants=new Map(captured.filter(candidate=>candidate.labels.length===choices.length&&labels.every((label,index)=>dynamic[index]||label===candidate.labels[index])).map(candidate=>[JSON.stringify(candidate.values),candidate.values]));
  }
  if(variants?.size!==1)return;
  const values=[...variants.values()][0];
  if(choices.some((choice,index)=>choice.attrs?.value!==undefined&&choice.attrs.value!==values[index]))return;
  choices.forEach((choice,index)=>{if(choice.attrs?.value===undefined)choice.attrs={...choice.attrs,value:values[index]};});
 });
 return next;
}
